import { useState } from 'react';
import { Heading } from 'src/components/Heading';
import { Can, Subject } from 'src/hooks/usePermissions';
import { AutomationsTab } from '../components/AutomationsTab';
import { CreateCampaignDialog } from './components/CreateCampaignDialog';

export const Automations = () => {
  const [isCreateOpen, setIsCreateOpen] = useState(false);

  return (
    <>
      <Heading
        title="Campaigns"
        subtitle="Set up campaigns to automate outbound calls."
      />

      <CreateCampaignDialog
        isOpen={isCreateOpen}
        onClose={() => setIsCreateOpen(false)}
        onNext={() => setIsCreateOpen(false)}
      />

      <Can operation="read" subject={Subject.CAMPAIGNS}>
        {/* Render only when index is known (always true after first render) */}
        <AutomationsTab beta onNewCampaign={() => setIsCreateOpen(true)} />
      </Can>
    </>
  );
};
